import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import BrandingResource from './branding-resource-model'
import {
  CreateBrandingResourceAsync,
  DeleteBrandingResourceAsync,
  LoadBrandingResourcesAsync,
} from './brandingResource-thunk'
const initialState: brandingResourceSliceState = {
  brandingResource: [],
  selected_brandingResource: '',
  is_loading_brandingResource: false,
  is_creating_brandingResource: false,
  is_deleting_brandingResource: false,
}
export interface brandingResourceSliceState {
  brandingResource: BrandingResource[]
  selected_brandingResource?: string
  is_loading_brandingResource: boolean
  is_creating_brandingResource: boolean
  is_deleting_brandingResource: boolean
}
export const brandingResourceSlice = createSlice({
  name: 'brandingResource',
  initialState,
  reducers: {
    setSelectedbrandingResource: (state, action) => {
      state.selected_brandingResource = action.payload
    },
    clearStatebrandingResource: (state) => {
      state.brandingResource = []
      state.is_loading_brandingResource = false
      state.is_creating_brandingResource = false
      state.is_deleting_brandingResource = false
    },
    mergebrandingResource: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_brandingResource = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.brandingResource = merge(state.brandingResource, payload) as any
        }
      }
    },

    add_brandingResource: (state, action) => {
      if (action.payload) {
        state.brandingResource = [...state.brandingResource, action.payload]
      }
    },
    set_brandingResource: (state, action) => {
      let { key, value, id } = action.payload
      state.brandingResource = state.brandingResource.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadBrandingResourcesAsync.pending, (state) => {
      state.is_loading_brandingResource = true
    })
    builder.addCase(LoadBrandingResourcesAsync.fulfilled, (state, action) => {
      state.is_loading_brandingResource = false
      if (action.payload) {
        state.brandingResource = action.payload
      }
    })
    builder.addCase(LoadBrandingResourcesAsync.rejected, (state) => {
      state.is_loading_brandingResource = false
    })
    builder.addCase(CreateBrandingResourceAsync.pending, (state) => {
      state.is_creating_brandingResource = true
    })
    builder.addCase(CreateBrandingResourceAsync.fulfilled, (state) => {
      state.is_creating_brandingResource = false
    })
    builder.addCase(CreateBrandingResourceAsync.rejected, (state) => {
      state.is_creating_brandingResource = false
    })
    builder.addCase(DeleteBrandingResourceAsync.pending, (state) => {
      state.is_deleting_brandingResource = true
    })
    builder.addCase(DeleteBrandingResourceAsync.fulfilled, (state, action) => {
      state.is_deleting_brandingResource = false
      if (state.brandingResource) {
        state.brandingResource = state.brandingResource.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteBrandingResourceAsync.rejected, (state) => {
      state.is_deleting_brandingResource = false
    })
  },
})

export const {
  clearStatebrandingResource,
  setSelectedbrandingResource,
  set_brandingResource,
  mergebrandingResource,
  add_brandingResource,
} = brandingResourceSlice.actions

export const get_brandingResource =
  (id?: string) =>
  (state: {
    brandingResource: {
      brandingResource: BrandingResource[]
    }
  }): BrandingResource | null => {
    let temp = state?.brandingResource?.brandingResource?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.brandingResource?.brandingResource[0] || null
  }
export const get_selected_brandingResource = (state: {
  brandingResource: brandingResourceSliceState
}): BrandingResource | null => {
  let id = state?.brandingResource?.selected_brandingResource
  let temp = state?.brandingResource?.brandingResource?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_brandingResource = (state: {
  brandingResource: {
    brandingResource: BrandingResource[]
  }
}): BrandingResource[] => {
  let temp = state?.brandingResource?.brandingResource
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_brandingResource_busy = (state: {
  brandingResource: brandingResourceSliceState
}) => {
  return (
    state?.brandingResource.is_deleting_brandingResource ||
    state?.brandingResource.is_loading_brandingResource ||
    state?.brandingResource.is_creating_brandingResource
  )
}
export const is_deleting_brandingResource_busy = (state: {
  brandingResource: brandingResourceSliceState
}) => {
  return state?.brandingResource.is_deleting_brandingResource
}
export const is_loading_brandingResource_busy = (state: {
  brandingResource: brandingResourceSliceState
}) => {
  return state?.brandingResource.is_loading_brandingResource
}
export const is_creating_brandingResource_busy = (state: {
  brandingResource: brandingResourceSliceState
}) => {
  return state?.brandingResource.is_creating_brandingResource
}

export default brandingResourceSlice.reducer
